import { render, staticRenderFns } from "./ServerReboot.vue?vue&type=template&id=6a90bcf6&"
import script from "./ServerReboot.vue?vue&type=script&lang=js&"
export * from "./ServerReboot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a90bcf6')) {
      api.createRecord('6a90bcf6', component.options)
    } else {
      api.reload('6a90bcf6', component.options)
    }
    module.hot.accept("./ServerReboot.vue?vue&type=template&id=6a90bcf6&", function () {
      api.rerender('6a90bcf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/ServerReboot.vue"
export default component.exports